import * as types from '../actionsTypes/pianificazioneCalendarioActionsType'
import {loadingOverlayActions, notifsActions} from '../index';
import new_axios_instance from '../../axios_instance';
import axios from 'axios';
import {
    convertBase64ToBlob,
    createMessageRequestException,
    encodeUnicode
} from "../../fanctionUtility";
import {loadStorage} from "../../sessionStorage";
import {
    PIANIFICAZIONE_CALENDARIO_RICERCA_FAIL,
    PIANIFICAZIONE_CALENDARIO_RICERCA_SUCCESS
} from "../actionsTypes/pianificazioneCalendarioActionsType";


export const initPianificazioneCalendario = () => dispatch => {
    dispatch({type: types.INIT_PIANIFICAZIONE_CALENDARIO});
    dispatch(initCustomToolbar());
};

export const initCustomToolbar = () => ({
    type: types.INIT_CUSTOM_TOOLBAR
});

export const resetPianificazioneCalendario = () => {
    return {
        type: types.RESET_PIANIFICAZIONI_CALENDARIO_FILTRO
    }
};

/******************************************* Cambio vista del calendario (Agenda, settimana, mese, etc) *****************************************************/

export const changeValuePlanning = (value) => {
    return {
        type: types.ALL_PLANNING,
        viewBool: value
    }
};

export const changeLabelMonthAgenda = (obj_label_month) => {
    return {
        type: types.LABEL_MONTH_AGENDA,
        obj_label_month: obj_label_month
    }
};

export const setMonth = (month) => {
    return {
        type: types.SET_MONTH,
        month: month
    }
};

/******************************************* Cambio vista del calendario (Agenda, settimana, mese, etc) *****************************************************/

/****************************************** Request per Pianificazioni Calendario filtrato *****************************************************************/

export const getPianificazioniCalendarioCrea = (requestFiltri) => ({
    type: types.PIANIFICAZIONE_CALENDARIO_CREATE,
    requestFiltri
})

export const initializationCalendario = (idCorso) => ({
    type: types.INITIALIZATION_CALENDARIO,
    idCorso
})

export const saveEstremi = (estremi) => ({
    type: types.SAVE_ESTREMI,
    estremi
})

export const getPianificazioniFiltroSuccess = (pianificazioneCalendario) => ({
    type: types.GET_PIANIFICAZIONE_CALENDARIO_SUCCESS,
    pianificazioneCalendario
});

export const getPianificazioniFiltroFail = (error) => ({
    type: types.GET_PIANIFICAZIONE_CALENDARIO_FAIL,
    error
});

/****************************************** Request per Pianificazioni Calendario filtrato *****************************************************************/
/****************************************** Request get PDF calednario/agenda ******************************************************************************/

export const getPDFAgenda = (json) => async dispatch => {
    const conf = loadStorage().configurationFile.fileConf;

    const headers = {
        ...new_axios_instance.defaults.headers
    };

    dispatch(loadingOverlayActions.showLoadingOverlay());
    dispatch(getPDFAgendaStart());

    await axios.post(`${conf.baseUrlPDFService}/${conf.contextPDFService}/v1/pdf/create`,
        {
            codeTemplate: "calendarioAgenda_docente",
            json: encodeUnicode(JSON.stringify(json))
        },
        {headers}
    ).then(response => {
        // dispatch(getPDFAgendaSuccess(response.data));
        convertBase64ToBlob(response.data, 'calendario.pdf');
        dispatch(loadingOverlayActions.hideLoadingOverlay());
    }).catch(error => {
        const message = createMessageRequestException(error);
        dispatch(notifsActions.notifError(message));
        dispatch(loadingOverlayActions.hideLoadingOverlay());
    })

}
const getPDFAgendaStart = () => ({
    type: types.GET_PDF_AGENDA_START
});


/****************************************** Request get PDF calednario/agenda ******************************************************************************/
/****************************************** Request per Pianificazione Giornaliera *****************************************************************/

export const getPianificazioneRicerca = (idCorso, data) => ({
    type: types.PIANIFICAZIONE_CALENDARIO_RICERCA,
    payload: { idCorso, data }
});

export const getPianificazioneRicercaSuccess = (pianificazioneGiornata) => ({
    type: types.PIANIFICAZIONE_CALENDARIO_RICERCA_SUCCESS,
    pianificazioneGiornata
});

export const getPianificazioneRicercaFail = (error) => ({
    type: types.PIANIFICAZIONE_CALENDARIO_RICERCA_FAIL,
    error
});

/****************************************** Request per Pianificazione Giornaliera *****************************************************************/





